export default "__VITE_ASSET__DLuhxByN__"